import { useClientPortalConfigContext } from "../../../context";
import { useGetQuery } from "hooks/useClientPortalQuery";
import { DocumentUploadConfigModel } from "types/generated/models";

export function useDocumentUploadConfig() {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const { data, isLoading } = useGetQuery<DocumentUploadConfigModel>({
        url: `/api/v1/${clientPortalGuid}/Documents/UploadConfig`,
    });

    return {
        config: data,
        isLoading,
    };
}
